<script>
  export let col, row;
</script>

<div class="max-w-[400px]">
    <pre class="max-w-[400px] whitespace-pre-wrap">{row.content}</pre>
</div>
